(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
const navigation = {
    toggleButton: null,
    header: null,
    headerWrapper: null,
    mobileMenuNav: null,
    mobileMenuOverlay: null,
    lastScrollY: 0,
    scrollTicking: false,
    boundHandleScroll: null,
    get mobileNavItems(){
        return Array.from(this.mobileMenuNav.querySelectorAll('[data-mobile-nav-item]'));
    },
    updateHeaderHeightVariable(){
        document.documentElement.style.setProperty('--header-height', this.header.offsetHeight + 'px');
    },
    closeMobileMenu() {
        this.toggleMobileMenu(false);
    },
    openMobileMenu() {
        this.toggleMobileMenu(true);
    },
    toggleMobileMenu(force) {
        const addedClass = this.mobileMenuNav.classList.toggle('active', force);
        this.toggleButton.classList.toggle('active', force);
        this.mobileMenuOverlay.classList.toggle('active', force);
        // never leave the menu attached to a hidden header
        if (addedClass) this.showHeader();
        return addedClass;
    },
    showHeader(){
        this.headerWrapper?.classList.remove('header--hidden');
    },
    hideHeader(){
        this.headerWrapper?.classList.add('header--hidden');
    },
    handleScroll(){
        if (this.scrollTicking) return;
        this.scrollTicking = true;
        requestAnimationFrame(() => {
            this.scrollTicking = false;
            const currentY = Math.max(window.scrollY, 0);
            const delta = currentY - this.lastScrollY;
            // ignore rubber-banding and sub-pixel jitter
            if (Math.abs(delta) < 5) return;
            const isMenuOpen = this.mobileMenuNav.classList.contains('active');
            if (delta > 0 && currentY > this.header.offsetHeight && !isMenuOpen) {
                this.hideHeader();
            } else if (delta < 0) {
                this.showHeader();
            }
            this.lastScrollY = currentY;
        });
    },
    bindScrollEvents(){
        if (this.boundHandleScroll) {
            window.removeEventListener('scroll', this.boundHandleScroll);
        }
        this.boundHandleScroll = this.handleScroll.bind(this);
        this.lastScrollY = Math.max(window.scrollY, 0);
        this.scrollTicking = false;
        window.addEventListener('scroll', this.boundHandleScroll, { passive: true });
    },
    bindNavigationEvents(){
        this.toggleButton.addEventListener('click', () => this.toggleMobileMenu());
        this.mobileMenuOverlay.addEventListener('click', () => this.toggleMobileMenu(false));
        const mediaQuery = window.matchMedia('(min-width: 1024px)');
        mediaQuery.addEventListener('change', this.updateHeaderHeightVariable.bind(this));
    },
    setupIcons() {
          const data = document.querySelectorAll('[data-nav-icon-json]');
          const navItems = this.mobileNavItems;
          data.forEach((item, index) => {
            try {
                const json = JSON.parse(item.innerHTML);
                const navItem = navItems[index];
                const navIconContainer = navItem?.querySelector('.nav-icon-container');
                if (json.icon && navIconContainer) {
                    const newIcon = document.createElement('img');
                    newIcon.src = json.icon;
                    newIcon.alt = navItem.textContent;
                    newIcon.classList.add('mobile-nav-icon');
                    navIconContainer.innerHTML = '';
                    navIconContainer.appendChild(newIcon);
                }
            } catch (error) {
                console.error('Error parsing JSON', item, error);
            }
          });
    },
    init() {
        this.header = document.querySelector('#main-header');
        this.headerWrapper = this.header?.closest('.section-header');
        this.mobileMenuNav = document.querySelector('.mobile-menu-nav');
        this.toggleButton = document.querySelector('.mobile-menu-toggle');
        this.mobileMenuOverlay = document.querySelector('.mobile-menu-bg-overlay');
        this.setupIcons();
        this.mobileNavItems.forEach(item => {
            item.addEventListener('click', () => this.closeMobileMenu());
        });
        if (this.toggleButton && this.header && this.mobileMenuNav) {
            this.bindNavigationEvents();
            this.bindScrollEvents();
            // initial update for header size
            this.updateHeaderHeightVariable();
        }
        else{
            console.error('Toggle button or mobile menu nav not found');
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    navigation.init();
});

document.addEventListener('shopify:section:load', (event) => {
  if (event.detail.sectionId === 'header') {
    navigation.init();
  }
});

// Re-initialize navigation after Vue mounts on the header element
document.addEventListener('vue:header-mounted', () => {
    navigation.init();
});

  } catch(e) { console.error(e); }
})();
})();
